import React  from 'react';
import styled from 'styled-components';
const Styles = styled.div`
  margin: 0.5rem 0;
  &.no-box {
    .over {
      padding: 1rem 0;
      background-color: transparent;
      box-shadow: none;
      border-radius: 0;
    }
  }
  .over {
    width: calc(100% - calc(var(--universal-pad) * 2) - 5rem);
    margin: 0 var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 2rem 2.5rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5rem;
    white-space: pre-wrap;
  }
  @media screen and (max-width: 850px) {
    &.no-box {
      .over {
        padding: 1rem;
        background-color: transparent;
        box-shadow: none;
        border-radius: 0;
      }
    }
    .over {
      width: calc(100% - calc(var(--universal-pad) * 2) - 2rem);
      padding: 2rem 1rem;
    }
  }
`
export default function TextBox11 (props){
  const {data: dataRaw, dataMain = {}} = props;
  const data = JSON.parse(dataRaw);
  const getModel = () => {
    if(data.model){
      if(parseInt(data.model) === 2){
        return "no-box"
      }
    }
    return ""
  }
  let dataText = data.Desc;
  if(typeof dataText === "string" && dataText.search("[country]") !== -1 && dataMain.Country){
    const regex = /\[country\]/gi;
    let replaceWith = "";
    if(props.lan.filename === "fa"){
      replaceWith = dataMain.Country.Country_Name
    }
    if(props.lan.filename === "en"){
      replaceWith = dataMain.Country.Country_En_Name
    }
    dataText = dataText.replaceAll(regex, replaceWith);
  }
  return (
    <Styles className={getModel()}>
      <pre className='over' dangerouslySetInnerHTML={{__html: dataText}}>
      </pre>
    </Styles>
  )
}

